import {useEffect} from 'react';

// Hook for checking if a mouse click occured outside a dom element, trigger a callback if true
function clickOutside(ref, onClickOutside, exceptionClassList = []) {
    useEffect(() => {

      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target) && !exceptionClassList.some(className => event.target.classList.contains(className)) ) {
          onClickOutside(event);
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref, onClickOutside]);
}

export default clickOutside;